export function getImageAlt(preferredAlt, fallbackDescription = 'CurateEd course guide image') {
  const normalize = (value) => (
    typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : ''
  );

  return normalize(preferredAlt) || normalize(fallbackDescription);
}

export function getCourseImageAlt(courseTitle) {
  const title = typeof courseTitle === 'string' ? courseTitle.trim() : '';
  return title ? `Course preview for ${title}` : 'Online course preview';
}

export function getCurationImageAlt(curationTitle) {
  const title = typeof curationTitle === 'string' ? curationTitle.trim() : '';
  return title ? `Course guide cover for ${title}` : 'Curated online course guide cover';
}

export function getHeroImageAlt(guideTitle) {
  const title = typeof guideTitle === 'string' ? guideTitle.trim() : '';
  return title ? `Featured image for ${title}` : 'Featured CurateEd course guide image';
}